import _objectWithoutProperties from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Component } from 'react';
import { Field } from 'redux-form';
import { getCustomStyles, mapValidation } from '@defi/core-utils';
import { withStyles } from '@material-ui/core/styles';
import TextFieldMasked from '../form/material/v4/TextFieldMasked';
const styles = {
  truncate: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  hide: {
    display: 'none'
  },
  default: {
    // height: 'auto',
    width: '100%',
    '& input': {
      padding: '3px',
      color: '#000',
      fontSize: '12px',
      height: 14
    },
    '& textarea': {
      padding: '3px',
      color: '#000',
      fontSize: 12,
      margin: '0 0 -7px 0',
      paddingTop: 1
    },
    '& p': {
      color: 'red',
      margin: '2px 0'
    }
  },
  edit: {
    '& input, & textarea': {
      border: '1px solid #ccc',
      backgroundColor: '#fff'
    }
  },
  disabled: {
    '& textarea': {
      padding: '3px 4px 4px 4px'
    }
  },
  error: {
    '& input': {
      border: '1px solid red',
      marginTop: 5
    }
  }
};
class TextInput extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      value: this.props.children.get('Value')
    };
    this.reachedMax = this.props.children.get('Value').length === this.props.children.getIn(['DataElement', 'FieldLength']);
    this.handleOnKeyUp = e => {
      if (e.target.value.length === this.props.fieldLength) {
        if (e.key !== 'Tab') {
          if (this.reachedMax) {
            this.props.toggleSnackbar(true, 'You have reached the maximum length of this input field', 'red');
          } else {
            this.reachedMax = true;
          }
        }
      } else {
        this.reachedMax = false;
      }
    };
  }
  UNSAFE_componentWillMount() {
    this.handleChangeRequirement(this.props.children.get('Value'));
  }
  componentDidUpdate() {
    if (this.props.editStatus && this.props.validation.length > 0) {
      if (!this.props.open) {
        this.props.toggleSection(true);
      }
    }
  }
  getClasses() {
    const _this$props = this.props,
      classes = _this$props.classes,
      editStatus = _this$props.editStatus;
    const statusClass = editStatus ? classes.edit : classes.disabled;
    return "".concat(classes.default, " ").concat(statusClass);
  }
  handleChangeRequirement(value) {
    this.props.changeRequirement(value, this.props.residencyDurationInYears, this.props.employmentDurationInYears);
  }
  // renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => {
  //   return (
  //     <InputMasked
  //       InputProps={{ disableUnderline: true }}
  //       id={String(this.props.children.get('ElementId'))}
  //       maxLength={this.props.children.getIn(['DataElement', 'FieldLength'])}
  //       mask={this.props.children.get('Mask')}
  //       disabled={this.props.disabled}
  //       multiline={this.props.children.get('IsExpandable')}
  //       className={
  //         `${this.getClasses()} ${touched && error ? this.props.classes.errorText : ''} ${this.props.disabled ? this.props.classes.hide : ''}`
  //       }
  //       helperText={touched && error}
  //       {...input}
  //       {...custom}
  //     />
  //   );
  // };

  //   render() {
  //     const customStyles = getCustomStyles(this.props.format);
  //     const { children, classes } = this.props;

  //     return (
  //       <div className={classes.truncate}>
  //         <span title={this.state.value} style={this.props.disabled ? customStyles : { display: 'none' }}>
  //           {children.get('IsExpandable')
  //             ? this.state.value
  //               .split('\n')
  //               .map((section, i) => <div key={i}>{section}</div>)
  //             : this.state.value}
  //         </span>
  //         <Field
  //           id={String(children.get('ElementId'))}
  //           name={String(children.get('DataElement').get('Id'))}
  //           component={this.renderTextField}
  //           onKeyUp={this.handleOnKeyUp}
  //           validate={this.props.validation}
  //           onBlur={e => this.handleChangeRequirement(e.target.value)}
  //         />
  //       </div>
  //     );
  //   }
  // }

  render() {
    const customStyles = getCustomStyles(this.props.format);
    // const { classes, context } = this.props;
    const _this$props2 = this.props,
      context = _this$props2.context,
      classes = _this$props2.classes,
      name = _this$props2.name,
      mask = _this$props2.mask,
      other = _objectWithoutProperties(_this$props2, ["context", "classes", "name", "mask"]); // const renderTextField = ({
    //   input,
    //   label,
    //   meta: { touched, error },
    //   ...custom
    // }) => (
    //     <InputMasked
    //       InputProps={{
    //         disableUnderline: true,
    //       }}
    //       id={this.props.id}
    //       maxLength={this.props.fieldLength}
    //       mask={this.props.mask}
    //       disabled={this.props.disabled}
    //       multiline={this.props.expandable}
    //       className={
    //         `${this.getClasses()} ${touched && error ? classes.error : ''} ${this.props.disabled ? classes.hide : ''}`
    //       }
    //       style={
    //         this.props.disabled ? { display: 'none' } : { display: 'inline' }
    //       }
    //       helperText={touched && error}
    //       {...input}
    //       {...custom}
    //       context={context}
    //     />
    //   );
    return /*#__PURE__*/React.createElement("div", {
      className: classes.truncate
    }, /*#__PURE__*/React.createElement("span", {
      title: this.state.value,
      style: this.props.disabled ? customStyles : {
        display: 'none'
      }
    }, this.props.expandable ? this.state.value.split('\n').map((section, i) => /*#__PURE__*/React.createElement("div", {
      key: i
    }, section)) : this.state.value), /*#__PURE__*/React.createElement(Field, Object.assign({
      context: context,
      name: name,
      mask: mask ? mask.toJS() : {
        hasMask: false
      },
      component: TextFieldMasked,
      onKeyUp: this.handleOnKeyUp,
      required: this.props.required,
      validate: this.props.validation,
      fullWidth: this.props.fullWidth,
      margin: this.props.margin,
      variant: "outlined",
      labelShrink: true,
      onBlur: e => this.handleChangeRequirement(this.props.dataElementName, e.target.value),
      ref: this.saveRef,
      forwardRef: true
    }, other)));
  }
}
export default withStyles(styles)(TextInput);